import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import useFileDownload from '@/hooks/useFiledDownload';
import VerifyDetails from './VerifyDetails';
import styles from './BankVerifyDetails.module.scss';
import { UtilButton } from 'UI';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Box, Title, Button, DropDown } = vp;

type FC = FunctionComponent;

type DataProps = {
  verification: vp.VerificationRequestsList;
};

const ElinxDetailsContainer: FC = () => {
  const { state } = useLocation<DataProps>();
  const { printFile, downloadPdfPage } = useFileDownload();
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isExportingPDF, setIsExportingPDF] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const { t } = useTranslation('translations', { keyPrefix: 'BankVerifyHistory' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const history = useHistory();

  useEffect(() => {
    if (isExportingPDF) {
      downloadPdfPage('bank-verify-overview', 'bank-verify-details');
    }

    if (isPrinting) {
      printFile('bank-verify-overview');
    }

    setIsExportingPDF(false);
    setIsPrinting(false);
  }, [isExportingPDF, isPrinting]);

  // The page renders entirely from router state; a navigation that can't
  // carry it (a deep link, or a link-out from the embedded accounting app)
  // falls back to the history list instead of crashing.
  if (!state?.verification) return <Redirect to="/bank-verify-history" />;

  return (
    <Box flx="col">
      <Box mb="lg" jc="sb" ai="center">
        <Box flx="col" gapSize="16px">
          <UtilButton
            iconLeft="chevron_left"
            size="large"
            onClick={() => {
              if (history.length > 1) {
                history.goBack();
              } else {
                history.replace('/bank-verify-history');
              }
            }}
          >
            {history.length > 1 ? tGlobal('Buttons.back') : t('title')}
          </UtilButton>

          <Title title="Verification Request Overview" />
        </Box>

        <Box flx="row" gap="sm" maxheight="42px">
          <div className={styles.dropdownContainer}>
            <Button
              id="export-transactions"
              color="none"
              label="Export"
              height="42px"
              textSize={1}
              background="transparent"
              noShadow
              icon="arrowDown"
              iconLocation="right"
              onClick={() => {
                setIsMenuVisible(true);
              }}
            />

            {isMenuVisible && (
              <DropDown isMenuVisible={isMenuVisible} onClick={setIsMenuVisible}>
                <Button
                  id="export-PDF-btn"
                  label="PDF"
                  background="transparent"
                  textSize={1}
                  width="100%"
                  noShadow
                  onClick={() => {
                    setIsExportingPDF(true);
                  }}
                />

                <Button
                  id="export-Print-btn"
                  label="Print"
                  background="transparent"
                  textSize={1}
                  width="100%"
                  noShadow
                  onClick={() => {
                    setIsPrinting(true);
                  }}
                />
              </DropDown>
            )}
          </div>
        </Box>
      </Box>

      <div id="bank-verify-overview">
        <VerifyDetails verification={state.verification} />
      </div>
    </Box>
  );
};

export default ElinxDetailsContainer;
